module.exports = __webpack_public_path__ + "static/media/clock.722bdeb4.svg";